import * as React from "react";

function SvgPlateTypeEditor(props: React.SVGProps<SVGSVGElement>) {
  return (
    <svg width="1em" height="1em" viewBox="0 0 24 24" fill="none" {...props}>
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M0 14l2-2h13v12H0V14zm13 0h-2v2h2v-2zm-3 0H8v2h2v-2zm-3 0H5v2h2v-2zm-3 0H2v2h2v-2zm7 3h2v2h-2v-2zm0 3h2v2h-2v-2zm-9 2h2v-2H2v2zm3 0h2v-2H5v2zm3 0h2v-2H8v2zm2-5v2H8v-2h2zm-3 0v2H5v-2h2zm-3 0v2H2v-2h2zM4.364 7.818L11.182 1 13 2.818 6.182 9.636 4.364 7.818zM3 11l.91-2.727 1.817 1.818L3 11z"
        fill="#fff"
      />
      <path fill="#fff" d="M13 6h9v1h-9zM10 8h9v1h-9zM7 10h17v1H7z" />
    </svg>
  );
}

export default SvgPlateTypeEditor;
